import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-income-requirements',
  templateUrl: './income-requirements.component.html',
  styleUrls: ['./income-requirements.component.css']
})
export class IncomeRequirementsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
